module.exports = __webpack_public_path__ + "img/27.f6ae2cf6.png";